import { render } from "./professionKnowledgeManager.vue?vue&type=template&id=3414da1e"
import script from "./professionKnowledgeManager.vue?vue&type=script&lang=js"
export * from "./professionKnowledgeManager.vue?vue&type=script&lang=js"

import "./professionKnowledgeManager.vue?vue&type=style&index=0&id=3414da1e&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__